// import React, { useState, useEffect, useMemo } from 'react';
// import { getBookingsByDateAndBus } from '../../Services/Operations/ProductAPI';

// const getTodayStr = () => new Date().toISOString().split('T')[0];

// // "Madhumita Bag" -> "MB", "Souvik" -> "SO"
// const getInitials = (fullName = '') => {
//   const parts = fullName.trim().split(/\s+/).filter(Boolean);
//   if (parts.length === 0) return '?';
//   if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
//   return (parts[0][0] + parts[1][0]).toUpperCase();
// };

// // Bookings in these statuses occupy a seat. Cancelled/expired free it back up.
// const ACTIVE_STATUSES = ['confirmed', 'in-progress', 'inprogress'];

// // Parse "3*2", "2*2", "3*3" etc into { left: 3, right: 2 }
// const parseSeatConfig = (busType) => {
//   if (!busType || typeof busType !== 'string') return { left: 2, right: 2 }; // sane default
//   const match = busType.match(/(\d+)\s*\*\s*(\d+)/);
//   if (!match) return { left: 2, right: 2 };
//   return { left: parseInt(match[1], 10), right: parseInt(match[2], 10) };
// };

// // Get total columns based on bus type
// const getTotalColumns = (busType) => {
//   const { left, right } = parseSeatConfig(busType);
//   return left + right;
// };

// const LiveSeatStatusModal = ({ bus, token, onClose }) => {
//   const [selectedDate, setSelectedDate] = useState(getTodayStr());
//   const [bookings, setBookings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchBookings(selectedDate);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedDate]);

//   const fetchBookings = async (date) => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await getBookingsByDateAndBus(token, bus.id, date);
//       if (response && response.success) {
//         setBookings(response.data || []);
//       } else {
//         setBookings([]);
//       }
//     } catch (err) {
//       console.error('Error fetching seat status:', err);
//       setError('Failed to load seat status for this date.');
//       setBookings([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Split bookings into instant-ticket counts and seat-level occupancy, per direction
//   const { instantCounts, seatStatusByDirection } = useMemo(() => {
//     const instant = { UP: 0, DOWN: 0, total: 0 };
//     const seatMap = { UP: {}, DOWN: {} };

//     bookings.forEach((booking) => {
//       const status = (booking.status || '').toLowerCase();
//       const isActive = ACTIVE_STATUSES.includes(status);
//       if (!isActive) return; // skip cancelled / expired bookings

//       const direction = booking.journeyDetails?.direction === 'DOWN' ? 'DOWN' : 'UP';

//       if (booking.isInstantBooking) {
//         instant[direction] += 1;
//         instant.total += 1;
//         return;
//       }

//       (booking.seats || []).forEach((seat) => {
//         seatMap[direction][seat.seatNumber] = {
//           booked: true,
//           initials: getInitials(seat.passenger?.fullName)
//         };
//       });
//     });

//     return { instantCounts: instant, seatStatusByDirection: seatMap };
//   }, [bookings]);

//   // left/right seat counts derived from bus.seatConfiguration.busType (e.g. "3*2")
//   const { left: leftCount, right: rightCount } = useMemo(
//     () => parseSeatConfig(bus.seatConfiguration?.busType),
//     [bus.seatConfiguration]
//   );

//   // Group the bus's static seat layout by row (sorted by column) for grid rendering
//   const seatRows = useMemo(() => {
//     const rowsMap = {};
//     (bus.seats || []).forEach((seat) => {
//       if (!rowsMap[seat.row]) rowsMap[seat.row] = [];
//       rowsMap[seat.row].push(seat);
//     });
//     return Object.keys(rowsMap)
//       .map(Number)
//       .sort((a, b) => a - b)
//       .map((rowNum) => rowsMap[rowNum].sort((a, b) => a.column - b.column));
//   }, [bus.seats]);

//   const totalBookedSeats = useMemo(() => {
//     return (
//       Object.keys(seatStatusByDirection.UP || {}).length +
//       Object.keys(seatStatusByDirection.DOWN || {}).length
//     );
//   }, [seatStatusByDirection]);

//   const renderSeatBox = (seat, statusMap, isBooked = false) => {
//     const info = statusMap[seat.seatNumber];
//     const booked = isBooked || !!info?.booked;
//     return (
//       <div
//         key={seat.seatNumber}
//         title={booked ? `${seat.seatNumber} - Booked` : `${seat.seatNumber} - Available`}
//         className={`seat-box ${booked ? 'seat-booked' : 'seat-available'}`}
//       >
//         {booked ? (info?.initials || '') : seat.seatNumber}
//       </div>
//     );
//   };

//   // Get seats for a specific row based on position
//   const getSeatsByPosition = (row, position) => {
//     return row.filter(seat => seat.position === position);
//   };

//   const renderSeatGrid = (direction) => {
//     const statusMap = seatStatusByDirection[direction] || {};

//     if (seatRows.length === 0) {
//       return <p style={{ fontSize: '13px', color: '#666' }}>No seat layout available for this bus.</p>;
//     }

//     // Get the bus type string to determine column count
//     const busType = bus.seatConfiguration?.busType || '2*2';
//     const totalColumns = getTotalColumns(busType);

//     return (
//       <div className="seat-grid1">
//         {seatRows.map((row, rowIdx) => {
//           // Check if this is a back row (all seats have position 'back')
//           const isBackRow = row.every((s) => s.position === 'back');

//           if (isBackRow) {
//             return (
//               <div className="seat-row seat-row-back" key={rowIdx}>
//                 {row.map((seat) => renderSeatBox(seat, statusMap))}
//               </div>
//             );
//           }

//           // For regular rows: split into left and right based on column number
//           const leftSeats = row.filter((s) => s.position === 'left' || s.column <= leftCount);
//           const rightSeats = row.filter((s) => s.position === 'right' || s.column > leftCount);
          
//           // If no seats found by position, fall back to column-based split
//           const finalLeftSeats = leftSeats.length > 0 ? leftSeats : row.slice(0, leftCount);
//           const finalRightSeats = rightSeats.length > 0 ? rightSeats : row.slice(leftCount);

//           return (
//             <div className="seat-row" key={rowIdx}>
//               <div className="seat-row-block seat-row-left">
//                 {finalLeftSeats.map((seat) => renderSeatBox(seat, statusMap))}
//               </div>
//               <div className="seat-aisle-gap" />
//               <div className="seat-row-block seat-row-right">
//                 {finalRightSeats.map((seat) => renderSeatBox(seat, statusMap))}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     );
//   };

//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div
//         className="modal-content1 seat-status-modal"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="modal-header">
//           <h3>Live Seat Status: {bus.busNumber} - {bus.busName}</h3>
//           <button className="modal-close-btn" onClick={onClose}>×</button>
//         </div>

//         <div className="modal-body">
//           <div className="seat-status-controls">
//             <label>
//               Date:&nbsp;
//               <input
//                 type="date"
//                 value={selectedDate}
//                 onChange={(e) => setSelectedDate(e.target.value)}
//               />
//             </label>
//             <button className="refresh-btn" onClick={() => fetchBookings(selectedDate)}>
//               Refresh
//             </button>
//           </div>

//           {loading && <p>Loading seat status...</p>}
//           {error && <p style={{ color: 'red' }}>{error}</p>}

//           {!loading && !error && (
//             <>
//               <div className="instant-badges-row">
//                 <div className="instant-ticket-badge">
//                   Instant Tickets (UP): <strong>{instantCounts.UP}</strong>
//                 </div>
//                 <div className="instant-ticket-badge">
//                   Instant Tickets (DOWN): <strong>{instantCounts.DOWN}</strong>
//                 </div>
//                 <div className="instant-ticket-badge">
//                   Total Instant: <strong>{instantCounts.total}</strong>
//                 </div>
//                 <div className="instant-ticket-badge">
//                   Total Seats Booked: <strong>{totalBookedSeats}</strong>
//                 </div>
//               </div>

//               <div className="seat-legend">
//                 <span><span className="legend-swatch seat-available"></span> Available</span>
//                 <span><span className="legend-swatch seat-booked"></span> Booked</span>
//               </div>

//               <div className="seat-grid1s-wrapper">
//                 <div className="seat-grid1-column">
//                   <h4 style={{ textAlign: 'center' }}>UP Direction</h4>
//                   {renderSeatGrid('UP')}
//                 </div>
//                 <div className="seat-grid1-divider" />
//                 <div className="seat-grid1-column">
//                   <h4 style={{ textAlign: 'center' }}>DOWN Direction</h4>
//                   {renderSeatGrid('DOWN')}
//                 </div>
//               </div>
//             </>
//           )}
//         </div>

//         <div className="modal-footer">
//           <button className="modal-close-btn secondary" onClick={onClose}>
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LiveSeatStatusModal;


// import React, { useState, useEffect, useMemo } from 'react';
// import { getBookingsByDateAndBus } from '../../Services/Operations/ProductAPI';

// const getTodayStr = () => new Date().toISOString().split('T')[0];

// // "Madhumita Bag" -> "MB", "Souvik" -> "SO"
// const getInitials = (fullName = '') => {
//   const parts = fullName.trim().split(/\s+/).filter(Boolean);
//   if (parts.length === 0) return '?';
//   if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
//   return (parts[0][0] + parts[1][0]).toUpperCase();
// };

// // Bookings in these statuses occupy a seat. Cancelled/expired free it back up.
// const ACTIVE_STATUSES = ['confirmed', 'in-progress', 'inprogress'];

// // Parse "3*2", "2*2", "3*3" etc into { left: 3, right: 2 }
// const parseSeatConfig = (busType) => {
//   if (!busType || typeof busType !== 'string') return { left: 2, right: 2 };
//   const match = busType.match(/(\d+)\s*\*\s*(\d+)/);
//   if (!match) return { left: 2, right: 2 };
//   return { left: parseInt(match[1], 10), right: parseInt(match[2], 10) };
// };

// const LiveSeatStatusModal = ({ bus, token, onClose }) => {
//   console.log("Bus ::::::::::::: ",bus)
//   const [selectedDate, setSelectedDate] = useState(getTodayStr());
//   const [selectedDirection, setSelectedDirection] = useState('UP');
//   const [selectedTimeSlot, setSelectedTimeSlot] = useState(1);
//   const [bookings, setBookings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [availableTimeSlots, setAvailableTimeSlots] = useState([]);

//   useEffect(() => {
//     fetchBookings(selectedDate);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedDate]);

//   const fetchBookings = async (date) => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await getBookingsByDateAndBus(token, bus.id, date);
//       if (response && response.success) {
//         setBookings(response.data || []);
//       } else {
//         setBookings([]);
//       }
//     } catch (err) {
//       console.error('Error fetching seat status:', err);
//       setError('Failed to load seat status for this date.');
//       setBookings([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Extract time slots from bus routeSchedules
//   const extractTimeSlots = () => {
//     const slots = [];
    
//     console.log('Bus routeSchedules:', bus.routeSchedules);
    
//     if (bus.routeSchedules && bus.routeSchedules.length > 0) {
//       // Find route schedule for selected direction
//       const routeSchedule = bus.routeSchedules.find(rs => rs.direction === selectedDirection);
      
//       console.log('Route schedule for direction:', selectedDirection, routeSchedule);
      
//       if (routeSchedule) {
//         // Get time slots from origin timings (departure times)
//         const originTimings = routeSchedule.origin?.timings || [];
//         const destTimings = routeSchedule.destination?.timings || [];
        
//         // If origin has timings with departureTime
//         if (originTimings.length > 0) {
//           originTimings.forEach(timing => {
//             const slotNumber = timing.timeSlotSequence || 1;
//             const departureTime = timing.departureTime;
            
//             // Find corresponding arrival time from destination timings
//             let arrivalTime = null;
//             if (destTimings.length > 0) {
//               const destTiming = destTimings.find(
//                 t => t.timeSlotSequence === slotNumber
//               );
//               if (destTiming) {
//                 arrivalTime = destTiming.arrivalTime;
//               }
//             }
            
//             // Only add slot if departure time exists
//             if (departureTime) {
//               slots.push({
//                 slot: slotNumber,
//                 departureTime: departureTime,
//                 arrivalTime: arrivalTime || 'N/A',
//                 label: `Slot ${slotNumber} - ${departureTime} → ${arrivalTime || 'N/A'}`
//               });
//             }
//           });
//         }
        
//         // If no slots from origin, try destination timings (for DOWN direction)
//         if (slots.length === 0 && destTimings.length > 0) {
//           destTimings.forEach(timing => {
//             const slotNumber = timing.timeSlotSequence || 1;
//             const arrivalTime = timing.arrivalTime;
            
//             // Find corresponding departure time from origin timings
//             let departureTime = null;
//             if (originTimings.length > 0) {
//               const originTiming = originTimings.find(
//                 t => t.timeSlotSequence === slotNumber
//               );
//               if (originTiming) {
//                 departureTime = originTiming.departureTime;
//               }
//             }
            
//             // Only add slot if arrival time exists
//             if (arrivalTime) {
//               slots.push({
//                 slot: slotNumber,
//                 departureTime: departureTime || 'N/A',
//                 arrivalTime: arrivalTime,
//                 label: `Slot ${slotNumber} - ${departureTime || 'N/A'} → ${arrivalTime}`
//               });
//             }
//           });
//         }
        
//         // If still no slots, create from direct fields
//         if (slots.length === 0) {
//           const departureTime = routeSchedule.origin?.departureTime || 'N/A';
//           const arrivalTime = routeSchedule.destination?.arrivalTime || 'N/A';
//           if (departureTime !== 'N/A' || arrivalTime !== 'N/A') {
//             slots.push({
//               slot: 1,
//               departureTime: departureTime,
//               arrivalTime: arrivalTime,
//               label: `Slot 1 - ${departureTime} → ${arrivalTime}`
//             });
//           }
//         }
//       }
//     }
    
//     // If no route schedules or no slots found, create default slots
//     if (slots.length === 0) {
//       // Create default slots based on direction
//       if (selectedDirection === 'UP') {
//         slots.push({
//           slot: 1,
//           departureTime: 'N/A',
//           arrivalTime: 'N/A',
//           label: 'Slot 1'
//         });
//       } else {
//         slots.push({
//           slot: 1,
//           departureTime: 'N/A',
//           arrivalTime: 'N/A',
//           label: 'Slot 1'
//         });
//       }
//     }
    
//     // Sort slots by slot number
//     slots.sort((a, b) => a.slot - b.slot);
    
//     console.log('Extracted time slots:', slots);
//     setAvailableTimeSlots(slots);
    
//     // Set default time slot if current is not available
//     if (!slots.some(s => s.slot === selectedTimeSlot)) {
//       setSelectedTimeSlot(slots[0]?.slot || 1);
//     }
//   };

//   // Re-extract time slots when direction changes
//   useEffect(() => {
//     extractTimeSlots();
//     // Reset to first slot when direction changes
//     setSelectedTimeSlot(1);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedDirection]);

//   // Filter bookings by direction and time slot
//   const filteredBookings = useMemo(() => {
//     return bookings.filter(booking => {
//       const direction = booking.journeyDetails?.direction === 'DOWN' ? 'DOWN' : 'UP';
//       const timeSlot = booking.timeSlotSequence || 1;
//       return direction === selectedDirection && timeSlot === selectedTimeSlot;
//     });
//   }, [bookings, selectedDirection, selectedTimeSlot]);

//   // Split bookings into instant-ticket counts and seat-level occupancy
//   const { instantCounts, seatStatusByDirection } = useMemo(() => {
//     const instant = { UP: 0, DOWN: 0, total: 0 };
//     const seatMap = { UP: {}, DOWN: {} };

//     // Filter bookings for selected direction and time slot
//     const filtered = bookings.filter(booking => {
//       const direction = booking.journeyDetails?.direction === 'DOWN' ? 'DOWN' : 'UP';
//       const timeSlot = booking.timeSlotSequence || 1;
//       return direction === selectedDirection && timeSlot === selectedTimeSlot;
//     });

//     filtered.forEach((booking) => {
//       const status = (booking.status || '').toLowerCase();
//       const isActive = ACTIVE_STATUSES.includes(status);
//       if (!isActive) return;

//       const direction = booking.journeyDetails?.direction === 'DOWN' ? 'DOWN' : 'UP';

//       if (booking.isInstantBooking) {
//         instant[direction] += 1;
//         instant.total += 1;
//         return;
//       }

//       (booking.seats || []).forEach((seat) => {
//         seatMap[direction][seat.seatNumber] = {
//           booked: true,
//           initials: getInitials(seat.passenger?.fullName)
//         };
//       });
//     });

//     return { instantCounts: instant, seatStatusByDirection: seatMap };
//   }, [bookings, selectedDirection, selectedTimeSlot]);

//   // left/right seat counts derived from bus.seatConfiguration.busType
//   const { left: leftCount, right: rightCount } = useMemo(
//     () => parseSeatConfig(bus.seatConfiguration?.busType),
//     [bus.seatConfiguration]
//   );

//   // Group the bus's static seat layout by row
//   const seatRows = useMemo(() => {
//     const rowsMap = {};
//     (bus.seats || []).forEach((seat) => {
//       if (!rowsMap[seat.row]) rowsMap[seat.row] = [];
//       rowsMap[seat.row].push(seat);
//     });
//     return Object.keys(rowsMap)
//       .map(Number)
//       .sort((a, b) => a - b)
//       .map((rowNum) => rowsMap[rowNum].sort((a, b) => a.column - b.column));
//   }, [bus.seats]);

//   const totalBookedSeats = useMemo(() => {
//     return Object.keys(seatStatusByDirection[selectedDirection] || {}).length;
//   }, [seatStatusByDirection, selectedDirection]);

//   // Get blocked seats from bus data directly
//   const totalBlockedSeats = useMemo(() => {
//     return (bus.seats || []).filter(seat => seat.isBlocked === true).length;
//   }, [bus.seats]);

//   const renderSeatBox = (seat, statusMap) => {
//     const info = statusMap[seat.seatNumber];
//     const booked = !!info?.booked;
//     const isBlocked = seat.isBlocked === true;

//     const getSeatClassName = () => {
//       if (isBlocked) return 'seat-blocked';
//       if (booked) return 'seat-booked';
//       return 'seat-available';
//     };

//     const getSeatDisplayText = () => {
//       if (isBlocked) return '🚫';
//       if (booked) return info?.initials || 'B';
//       return seat.seatNumber;
//     };

//     const getSeatTitle = () => {
//       if (isBlocked) return `${seat.seatNumber} - Blocked`;
//       if (booked) return `${seat.seatNumber} - Booked by ${info?.initials || 'Passenger'}`;
//       return `${seat.seatNumber} - Available`;
//     };

//     return (
//       <div
//         key={seat.seatNumber}
//         title={getSeatTitle()}
//         className={`seat-box ${getSeatClassName()}`}
//       >
//         {getSeatDisplayText()}
//       </div>
//     );
//   };

//   const renderSeatGrid = () => {
//     const statusMap = seatStatusByDirection[selectedDirection] || {};

//     if (seatRows.length === 0) {
//       return <p style={{ fontSize: '13px', color: '#666' }}>No seat layout available for this bus.</p>;
//     }

//     return (
//       <div className="seat-grid1">
//         {seatRows.map((row, rowIdx) => {
//           const isBackRow = row.every((s) => s.position === 'back');

//           if (isBackRow) {
//             return (
//               <div className="seat-row seat-row-back" key={rowIdx}>
//                 {row.map((seat) => renderSeatBox(seat, statusMap))}
//               </div>
//             );
//           }

//           const leftSeats = row.filter((s) => s.position === 'left' || s.column <= leftCount);
//           const rightSeats = row.filter((s) => s.position === 'right' || s.column > leftCount);
          
//           const finalLeftSeats = leftSeats.length > 0 ? leftSeats : row.slice(0, leftCount);
//           const finalRightSeats = rightSeats.length > 0 ? rightSeats : row.slice(leftCount);

//           return (
//             <div className="seat-row" key={rowIdx}>
//               <div className="seat-row-block seat-row-left">
//                 {finalLeftSeats.map((seat) => renderSeatBox(seat, statusMap))}
//               </div>
//               <div className="seat-aisle-gap" />
//               <div className="seat-row-block seat-row-right">
//                 {finalRightSeats.map((seat) => renderSeatBox(seat, statusMap))}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     );
//   };

//   // Get current time slot label
//   const getCurrentTimeSlotLabel = () => {
//     const slot = availableTimeSlots.find(s => s.slot === selectedTimeSlot);
//     if (slot) {
//       return `${slot.departureTime || 'N/A'} → ${slot.arrivalTime || 'N/A'}`;
//     }
//     return 'N/A → N/A';
//   };

//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div
//         className="modal-content1 seat-status-modal"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="modal-header">
//           <h3>Live Seat Status: {bus.busNumber} - {bus.busName}</h3>
//           <button className="modal-close-btn" onClick={onClose}>×</button>
//         </div>

//         <div className="modal-body">
//           {/* Controls: Date, Direction, Time Slot */}
//           <div className="seat-status-controls">
//             <div className="control-group">
//               <label>
//                 Date:&nbsp;
//                 <input
//                   type="date"
//                   value={selectedDate}
//                   onChange={(e) => setSelectedDate(e.target.value)}
//                 />
//               </label>
//             </div>

//             <div className="control-group">
//               <label>
//                 Direction:&nbsp;
//                 <select 
//                   value={selectedDirection} 
//                   onChange={(e) => setSelectedDirection(e.target.value)}
//                   className="direction-select"
//                 >
//                   <option value="UP">UP Journey</option>
//                   <option value="DOWN">DOWN Journey</option>
//                 </select>
//               </label>
//             </div>

//             <div className="control-group">
//               <label>
//                 Time Slot:&nbsp;
//                 <select 
//                   value={selectedTimeSlot} 
//                   onChange={(e) => setSelectedTimeSlot(Number(e.target.value))}
//                   className="timeslot-select"
//                 >
//                   {availableTimeSlots.map((slot) => (
//                     <option key={slot.slot} value={slot.slot}>
//                       Slot {slot.slot} - {slot.departureTime || 'N/A'} → {slot.arrivalTime || 'N/A'}
//                     </option>
//                   ))}
//                 </select>
//               </label>
//             </div>

//             <button className="refresh-btn" onClick={() => fetchBookings(selectedDate)}>
//               Refresh
//             </button>
//           </div>

//           {/* Trip Info */}
//           <div className="trip-info">
//             <div className="trip-route">
//               <span className="direction-label">{selectedDirection} Journey</span>
//               <span className="time-slot-label">
//                 Slot {selectedTimeSlot} - {getCurrentTimeSlotLabel()}
//               </span>
//             </div>
//             <div className="bus-info-summary">
//               <span className="bus-name">{bus.busName}</span>
//               <span className="bus-number">{bus.busNumber}</span>
//               <span className="seat-count">
//                 Available Seats: {bus.totalSeats - totalBookedSeats - totalBlockedSeats} / {bus.totalSeats}
//               </span>
//             </div>
//           </div>

//           {loading && <p className="loading-text">Loading seat status...</p>}
//           {error && <p className="error-text" style={{ color: 'red' }}>{error}</p>}

//           {!loading && !error && (
//             <>
//               <div className="instant-badges-row">
//                 <div className="instant-ticket-badge">
//                   Instant Tickets (UP): <strong>{instantCounts.UP}</strong>
//                 </div>
//                 <div className="instant-ticket-badge">
//                   Instant Tickets (DOWN): <strong>{instantCounts.DOWN}</strong>
//                 </div>
//                 <div className="instant-ticket-badge">
//                   Total Instant: <strong>{instantCounts.total}</strong>
//                 </div>
//                 <div className="instant-ticket-badge">
//                   Total Seats Booked: <strong>{totalBookedSeats}</strong>
//                 </div>
//                 <div className="instant-ticket-badge blocked-badge">
//                   Blocked: <strong>{totalBlockedSeats}</strong>
//                 </div>
//               </div>

//               <div className="seat-legend">
//                 <span><span className="legend-swatch seat-available"></span> Available</span>
//                 <span><span className="legend-swatch seat-booked"></span> Booked</span>
//                 <span><span className="legend-swatch seat-blocked"></span> Blocked</span>
//               </div>

//               <div className="seat-grid-wrapper">
//                 <div className="seat-grid-column">
//                   <h4 style={{ textAlign: 'center' }}>
//                     {selectedDirection} Direction - Slot {selectedTimeSlot}
//                   </h4>
//                   {renderSeatGrid()}
//                 </div>
//               </div>

//               {/* Driver & Conductor Info */}
//               {(bus.driver || bus.conductor) && (
//                 <div className="staff-info">
//                   {bus.driver && (
//                     <div className="staff-item">
//                       <span className="staff-label">Driver:</span>
//                       <span className="staff-name">{bus.driver.name || 'N/A'}</span>
//                     </div>
//                   )}
//                   {bus.conductor && (
//                     <div className="staff-item">
//                       <span className="staff-label">Conductor:</span>
//                       <span className="staff-name">{bus.conductor.name || 'N/A'}</span>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         <div className="modal-footer">
//           <button className="modal-close-btn secondary" onClick={onClose}>
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LiveSeatStatusModal;

// import React, { useState, useEffect, useMemo } from 'react';
// import { getBookingsByDateAndBus, getBusSeatAvailability } from '../../Services/Operations/ProductAPI';

// const getTodayStr = () => new Date().toISOString().split('T')[0];

// // "Madhumita Bag" -> "MB", "Souvik" -> "SO"
// const getInitials = (fullName = '') => {
//   const parts = fullName.trim().split(/\s+/).filter(Boolean);
//   if (parts.length === 0) return '?';
//   if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
//   return (parts[0][0] + parts[1][0]).toUpperCase();
// };

// // Bookings in these statuses occupy a seat. Cancelled/expired free it back up.
// const ACTIVE_STATUSES = ['confirmed', 'in-progress', 'inprogress'];

// // Parse "3*2", "2*2", "3*3" etc into { left: 3, right: 2 }
// const parseSeatConfig = (busType) => {
//   if (!busType || typeof busType !== 'string') return { left: 2, right: 2 };
//   const match = busType.match(/(\d+)\s*\*\s*(\d+)/);
//   if (!match) return { left: 2, right: 2 };
//   return { left: parseInt(match[1], 10), right: parseInt(match[2], 10) };
// };

// const LiveSeatStatusModal = ({ bus, token, onClose }) => {
//   console.log("Bus ::::::::::::: ", bus);
//   const [selectedDate, setSelectedDate] = useState(getTodayStr());
//   const [selectedDirection, setSelectedDirection] = useState('UP');
//   const [selectedTimeSlot, setSelectedTimeSlot] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  
//   // State for seat data from API
//   const [seatData, setSeatData] = useState(null);
//   const [bookedSeatsMap, setBookedSeatsMap] = useState({});
//   const [blockedSeatsMap, setBlockedSeatsMap] = useState({});
//   const [totalBookedSeats, setTotalBookedSeats] = useState(0);
//   const [totalBlockedSeats, setTotalBlockedSeats] = useState(0);
//   const [availableSeats, setAvailableSeats] = useState(bus.totalSeats || 0);
//   const [instantCounts, setInstantCounts] = useState({ UP: 0, DOWN: 0, total: 0 });

//   // Extract time slots from bus routeSchedules
//   const extractTimeSlots = () => {
//     const slots = [];
    
//     console.log('Bus routeSchedules:', bus.routeSchedules);
    
//     if (bus.routeSchedules && bus.routeSchedules.length > 0) {
//       const routeSchedule = bus.routeSchedules.find(rs => rs.direction === selectedDirection);
      
//       console.log('Route schedule for direction:', selectedDirection, routeSchedule);
      
//       if (routeSchedule) {
//         const originTimings = routeSchedule.origin?.timings || [];
//         const destTimings = routeSchedule.destination?.timings || [];
        
//         if (originTimings.length > 0) {
//           originTimings.forEach(timing => {
//             const slotNumber = timing.timeSlotSequence || 1;
//             const departureTime = timing.departureTime;
            
//             let arrivalTime = null;
//             if (destTimings.length > 0) {
//               const destTiming = destTimings.find(
//                 t => t.timeSlotSequence === slotNumber
//               );
//               if (destTiming) {
//                 arrivalTime = destTiming.arrivalTime;
//               }
//             }
            
//             if (departureTime) {
//               slots.push({
//                 slot: slotNumber,
//                 departureTime: departureTime,
//                 arrivalTime: arrivalTime || 'N/A',
//                 label: `Slot ${slotNumber} - ${departureTime} → ${arrivalTime || 'N/A'}`
//               });
//             }
//           });
//         }
        
//         if (slots.length === 0 && destTimings.length > 0) {
//           destTimings.forEach(timing => {
//             const slotNumber = timing.timeSlotSequence || 1;
//             const arrivalTime = timing.arrivalTime;
            
//             let departureTime = null;
//             if (originTimings.length > 0) {
//               const originTiming = originTimings.find(
//                 t => t.timeSlotSequence === slotNumber
//               );
//               if (originTiming) {
//                 departureTime = originTiming.departureTime;
//               }
//             }
            
//             if (arrivalTime) {
//               slots.push({
//                 slot: slotNumber,
//                 departureTime: departureTime || 'N/A',
//                 arrivalTime: arrivalTime,
//                 label: `Slot ${slotNumber} - ${departureTime || 'N/A'} → ${arrivalTime}`
//               });
//             }
//           });
//         }
        
//         if (slots.length === 0) {
//           const departureTime = routeSchedule.origin?.departureTime || 'N/A';
//           const arrivalTime = routeSchedule.destination?.arrivalTime || 'N/A';
//           if (departureTime !== 'N/A' || arrivalTime !== 'N/A') {
//             slots.push({
//               slot: 1,
//               departureTime: departureTime,
//               arrivalTime: arrivalTime,
//               label: `Slot 1 - ${departureTime} → ${arrivalTime}`
//             });
//           }
//         }
//       }
//     }
    
//     if (slots.length === 0) {
//       slots.push({
//         slot: 1,
//         departureTime: 'N/A',
//         arrivalTime: 'N/A',
//         label: 'Slot 1'
//       });
//     }
    
//     slots.sort((a, b) => a.slot - b.slot);
//     console.log('Extracted time slots:', slots);
//     setAvailableTimeSlots(slots);
    
//     if (!slots.some(s => s.slot === selectedTimeSlot)) {
//       setSelectedTimeSlot(slots[0]?.slot || 1);
//     }
//   };

//   // Fetch seat availability from API
//   const fetchSeatAvailability = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       console.log('📡 Fetching seat availability with:', {
//         busId: bus.id,
//         date: selectedDate,
//         direction: selectedDirection,
//         timeSlot: selectedTimeSlot
//       });

//       const response = await getBusSeatAvailability(
//         token,
//         bus.id,
//         selectedDate,
//         selectedDirection,
//         selectedTimeSlot
//       );

//       console.log('📦 Seat availability response:', response);

//       if (response && response.success) {
//         setSeatData(response);
        
//         // Find the direction data
//         const directionData = response.directions?.find(
//           d => d.direction === selectedDirection
//         );
        
//         if (directionData) {
//           // Find the time slot data
//           const slotData = directionData.timeSlots?.find(
//             s => s.timeSlot === selectedTimeSlot
//           );
          
//           if (slotData) {
//             // Process seat data
//             const bookedMap = {};
//             const blockedMap = {};
            
//             slotData.seats?.forEach(seat => {
//               if (seat.isBooked && !seat.isCancelled) {
//                 bookedMap[seat.seatNumber] = {
//                   passengerName: seat.passengerName || 'Unknown',
//                   bookingId: seat.bookingId,
//                   pnr: seat.pnr,
//                   initials: seat.passengerName ? getInitials(seat.passengerName) : 'B'
//                 };
//               }
//               if (seat.isBlocked) {
//                 blockedMap[seat.seatNumber] = true;
//               }
//             });
            
//             setBookedSeatsMap(bookedMap);
//             setBlockedSeatsMap(blockedMap);
//             setTotalBookedSeats(slotData.bookedSeats || 0);
//             setTotalBlockedSeats(slotData.blockedSeats || 0);
//             setAvailableSeats(slotData.availableSeats || 0);
            
//             // Update instant counts if available
//             if (slotData.instantCounts) {
//               setInstantCounts(slotData.instantCounts);
//             }
//           }
//         }
//       } else {
//         setError(response?.message || 'Failed to fetch seat availability');
//         // Fallback to bookings API
//         await fetchBookingsFallback();
//       }
//     } catch (err) {
//       console.error('Error fetching seat availability:', err);
//       setError(err.message || 'Failed to load seat availability');
//       // Fallback to bookings API
//       await fetchBookingsFallback();
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fallback: Use existing bookings API
//   const fetchBookingsFallback = async () => {
//     try {
//       console.log('🔄 Using fallback bookings API');
//       const response = await getBookingsByDateAndBus(token, bus.id, selectedDate);
//       if (response && response.success) {
//         const bookings = response.data || [];
//         processBookingsData(bookings);
//       }
//     } catch (err) {
//       console.error('Error in fallback:', err);
//       setError('Failed to load seat data. Please try again.');
//     }
//   };

//   // Process bookings data (fallback)
//   const processBookingsData = (bookings) => {
//     const instant = { UP: 0, DOWN: 0, total: 0 };
//     const bookedMap = {};
//     const blockedMap = {};

//     // Get blocked seats from bus data
//     (bus.seats || []).forEach(seat => {
//       if (seat.isBlocked === true) {
//         blockedMap[seat.seatNumber] = true;
//       }
//     });

//     bookings.forEach((booking) => {
//       const direction = booking.journeyDetails?.direction === 'DOWN' ? 'DOWN' : 'UP';
//       const timeSlot = booking.timeSlotSequence || 1;
      
//       if (direction === selectedDirection && timeSlot === selectedTimeSlot) {
//         const status = (booking.status || '').toLowerCase();
//         const isActive = ACTIVE_STATUSES.includes(status);
        
//         if (!isActive) return;

//         if (booking.isInstantBooking) {
//           instant[direction] += 1;
//           instant.total += 1;
//           return;
//         }

//         if (booking.seats) {
//           booking.seats.forEach((seat) => {
//             if (seat.seatNumber) {
//               bookedMap[seat.seatNumber] = {
//                 passengerName: seat.passenger?.fullName || 'Unknown',
//                 bookingId: booking._id,
//                 pnr: booking.pnr || booking.maskedPnr,
//                 initials: seat.passenger?.fullName ? getInitials(seat.passenger.fullName) : 'B'
//               };
//             }
//           });
//         }
//       }
//     });

//     setInstantCounts(instant);
//     setBookedSeatsMap(bookedMap);
//     setBlockedSeatsMap(blockedMap);
//     setTotalBookedSeats(Object.keys(bookedMap).length);
//     setTotalBlockedSeats(Object.keys(blockedMap).length);
//     setAvailableSeats(bus.totalSeats - Object.keys(bookedMap).length - Object.keys(blockedMap).length);
//   };

//   // Initial load and when date/direction/time slot changes
//   useEffect(() => {
//     extractTimeSlots();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedDirection]);

//   useEffect(() => {
//     if (bus.id && selectedDate) {
//       fetchSeatAvailability();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedDate, selectedDirection, selectedTimeSlot]);

//   // left/right seat counts derived from bus.seatConfiguration.busType
//   const { left: leftCount, right: rightCount } = useMemo(
//     () => parseSeatConfig(bus.seatConfiguration?.busType),
//     [bus.seatConfiguration]
//   );

//   // Group the bus's static seat layout by row
//   const seatRows = useMemo(() => {
//     const rowsMap = {};
//     (bus.seats || []).forEach((seat) => {
//       if (!rowsMap[seat.row]) rowsMap[seat.row] = [];
//       rowsMap[seat.row].push(seat);
//     });
//     return Object.keys(rowsMap)
//       .map(Number)
//       .sort((a, b) => a - b)
//       .map((rowNum) => rowsMap[rowNum].sort((a, b) => a.column - b.column));
//   }, [bus.seats]);

//   const renderSeatBox = (seat) => {
//     const info = bookedSeatsMap[seat.seatNumber];
//     const isBooked = !!info;
//     const isBlocked = seat.isBlocked === true || blockedSeatsMap[seat.seatNumber] === true;

//     const getSeatClassName = () => {
//       if (isBlocked) return 'seat-blocked';
//       if (isBooked) return 'seat-booked';
//       return 'seat-available';
//     };

//     const getSeatDisplayText = () => {
//       if (isBlocked) return '🚫';
//       if (isBooked) return info?.initials || 'B';
//       return seat.seatNumber;
//     };

//     const getSeatTitle = () => {
//       if (isBlocked) return `${seat.seatNumber} - Blocked`;
//       if (isBooked) return `${seat.seatNumber} - Booked by ${info?.passengerName || 'Passenger'}`;
//       return `${seat.seatNumber} - Available`;
//     };

//     return (
//       <div
//         key={seat.seatNumber}
//         title={getSeatTitle()}
//         className={`seat-box ${getSeatClassName()}`}
//       >
//         {getSeatDisplayText()}
//       </div>
//     );
//   };

//   const renderSeatGrid = () => {
//     if (seatRows.length === 0) {
//       return <p style={{ fontSize: '13px', color: '#666' }}>No seat layout available for this bus.</p>;
//     }

//     return (
//       <div className="seat-grid1">
//         {seatRows.map((row, rowIdx) => {
//           const isBackRow = row.every((s) => s.position === 'back');

//           if (isBackRow) {
//             return (
//               <div className="seat-row seat-row-back" key={rowIdx}>
//                 {row.map((seat) => renderSeatBox(seat))}
//               </div>
//             );
//           }

//           const leftSeats = row.filter((s) => s.position === 'left' || s.column <= leftCount);
//           const rightSeats = row.filter((s) => s.position === 'right' || s.column > leftCount);
          
//           const finalLeftSeats = leftSeats.length > 0 ? leftSeats : row.slice(0, leftCount);
//           const finalRightSeats = rightSeats.length > 0 ? rightSeats : row.slice(leftCount);

//           return (
//             <div className="seat-row" key={rowIdx}>
//               <div className="seat-row-block seat-row-left">
//                 {finalLeftSeats.map((seat) => renderSeatBox(seat))}
//               </div>
//               <div className="seat-aisle-gap" />
//               <div className="seat-row-block seat-row-right">
//                 {finalRightSeats.map((seat) => renderSeatBox(seat))}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     );
//   };

//   // Get current time slot label
//   const getCurrentTimeSlotLabel = () => {
//     const slot = availableTimeSlots.find(s => s.slot === selectedTimeSlot);
//     if (slot) {
//       return `${slot.departureTime || 'N/A'} → ${slot.arrivalTime || 'N/A'}`;
//     }
//     return 'N/A → N/A';
//   };

//   const totalSeats = bus.totalSeats || 0;
//   const totalAvailableSeats = totalSeats - totalBookedSeats - totalBlockedSeats;

//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div
//         className="modal-content1 seat-status-modal"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="modal-header">
//           <h3>Live Seat Status: {bus.busNumber} - {bus.busName}</h3>
//           <button className="modal-close-btn" onClick={onClose}>×</button>
//         </div>

//         <div className="modal-body">
//           {/* Controls: Date, Direction, Time Slot */}
//           <div className="seat-status-controls">
//             <div className="control-group">
//               <label>
//                 Date:&nbsp;
//                 <input
//                   type="date"
//                   value={selectedDate}
//                   onChange={(e) => setSelectedDate(e.target.value)}
//                 />
//               </label>
//             </div>

//             <div className="control-group">
//               <label>
//                 Direction:&nbsp;
//                 <select 
//                   value={selectedDirection} 
//                   onChange={(e) => setSelectedDirection(e.target.value)}
//                   className="direction-select"
//                 >
//                   <option value="UP">UP Journey</option>
//                   <option value="DOWN">DOWN Journey</option>
//                 </select>
//               </label>
//             </div>

//             <div className="control-group">
//               <label>
//                 Time Slot:&nbsp;
//                 <select 
//                   value={selectedTimeSlot} 
//                   onChange={(e) => setSelectedTimeSlot(Number(e.target.value))}
//                   className="timeslot-select"
//                 >
//                   {availableTimeSlots.map((slot) => (
//                     <option key={slot.slot} value={slot.slot}>
//                       Slot {slot.slot} - {slot.departureTime || 'N/A'} → {slot.arrivalTime || 'N/A'}
//                     </option>
//                   ))}
//                 </select>
//               </label>
//             </div>

//             <button className="refresh-btn" onClick={fetchSeatAvailability}>
//               Refresh
//             </button>
//           </div>

//           {/* Trip Info */}
//           <div className="trip-info">
//             <div className="trip-route">
//               <span className="direction-label">{selectedDirection} Journey</span>
//               <span className="time-slot-label">
//                 Slot {selectedTimeSlot} - {getCurrentTimeSlotLabel()}
//               </span>
//             </div>
//             <div className="bus-info-summary">
//               <span className="bus-name">{bus.busName}</span>
//               <span className="bus-number">{bus.busNumber}</span>
//               <span className="seat-count">
//                 Available Seats: {totalAvailableSeats} / {totalSeats}
//               </span>
//             </div>
//           </div>

//           {loading && <p className="loading-text">Loading seat status...</p>}
//           {error && <p className="error-text" style={{ color: 'red' }}>{error}</p>}

//           {!loading && !error && (
//             <>
//               <div className="instant-badges-row">
//                 <div className="instant-ticket-badge">
//                   Instant Tickets (UP): <strong>{instantCounts.UP || 0}</strong>
//                 </div>
//                 <div className="instant-ticket-badge">
//                   Instant Tickets (DOWN): <strong>{instantCounts.DOWN || 0}</strong>
//                 </div>
//                 <div className="instant-ticket-badge">
//                   Total Instant: <strong>{instantCounts.total || 0}</strong>
//                 </div>
//                 <div className="instant-ticket-badge">
//                   Total Seats Booked: <strong>{totalBookedSeats}</strong>
//                 </div>
//                 <div className="instant-ticket-badge blocked-badge">
//                   Blocked: <strong>{totalBlockedSeats}</strong>
//                 </div>
//               </div>

//               <div className="seat-legend">
//                 <span><span className="legend-swatch seat-available"></span> Available</span>
//                 <span><span className="legend-swatch seat-booked"></span> Booked</span>
//                 <span><span className="legend-swatch seat-blocked"></span> Blocked</span>
//               </div>

//               <div className="seat-grid-wrapper">
//                 <div className="seat-grid-column">
//                   <h4 style={{ textAlign: 'center' }}>
//                     {selectedDirection} Direction - Slot {selectedTimeSlot}
//                   </h4>
//                   {renderSeatGrid()}
//                 </div>
//               </div>

//               {/* Driver & Conductor Info */}
//               {(bus.driver || bus.conductor) && (
//                 <div className="staff-info">
//                   {bus.driver && (
//                     <div className="staff-item">
//                       <span className="staff-label">Driver:</span>
//                       <span className="staff-name">{bus.driver.name || 'N/A'}</span>
//                     </div>
//                   )}
//                   {bus.conductor && (
//                     <div className="staff-item">
//                       <span className="staff-label">Conductor:</span>
//                       <span className="staff-name">{bus.conductor.name || 'N/A'}</span>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         <div className="modal-footer">
//           <button className="modal-close-btn secondary" onClick={onClose}>
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LiveSeatStatusModal;

import React, { useState, useEffect, useMemo } from 'react';
import { getBookingsByDateAndBus, getBusSeatAvailability } from '../../Services/Operations/ProductAPI';

const getTodayStr = () => new Date().toISOString().split('T')[0];

// "Madhumita Bag" -> "MB", "Souvik" -> "SO"
const getInitials = (fullName = '') => {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

// Bookings in these statuses occupy a seat. Cancelled/expired free it back up.
const ACTIVE_STATUSES = ['confirmed', 'in-progress', 'inprogress'];

// Parse "3*2", "2*2", "3*3" etc into { left: 3, right: 2 }
const parseSeatConfig = (busType) => {
  if (!busType || typeof busType !== 'string') return { left: 2, right: 2 };
  const match = busType.match(/(\d+)\s*\*\s*(\d+)/);
  if (!match) return { left: 2, right: 2 };
  return { left: parseInt(match[1], 10), right: parseInt(match[2], 10) };
};

// Custom tooltip component
const SeatTooltip = ({ children, seat, bookedSeatsMap, blockedSeatsMap, busOwner }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const seatNumber = seat.seatNumber;
  const isBooked = !!bookedSeatsMap[seatNumber];
  const isBlocked = seat.isBlocked === true || blockedSeatsMap[seatNumber] === true;
  
  // Get seat data from API response
  const seatData = seat._apiData || {};
  const passengerDetails = seatData.passengerDetails || null;
  const ownerDetails = seatData.ownerDetails || null;
  
  // Get info from bookedSeatsMap (fallback)
  const bookingInfo = bookedSeatsMap[seatNumber];
  
  // Get PNR from multiple sources
  const getPnr = () => {
    if (passengerDetails?.pnr) return passengerDetails.pnr;
    if (bookingInfo?.pnr) return bookingInfo.pnr;
    if (seatData?.pnr) return seatData.pnr;
    if (bookingInfo?.passengerDetails?.pnr) return bookingInfo.passengerDetails.pnr;
    return null;
  };
  
  // Get passenger name from multiple sources
  const getPassengerName = () => {
    if (passengerDetails?.name) return passengerDetails.name;
    if (passengerDetails?.passengerName) return passengerDetails.passengerName;
    if (bookingInfo?.passengerName) return bookingInfo.passengerName;
    if (bookingInfo?.passengerDetails?.name) return bookingInfo.passengerDetails.name;
    if (bookingInfo?.passengerDetails?.passengerName) return bookingInfo.passengerDetails.passengerName;
    return null;
  };
  
  const getTooltipContent = () => {
    if (isBlocked) {
      // Show blocked seat info with owner details
      const owner = ownerDetails || busOwner;
      return (
        <div className="seat-tooltip-content blocked-tooltip">
          <h4>🚫 Blocked Seat</h4>
          <p><strong>Seat:</strong> {seatNumber}</p>
          {owner && (
            <>
              <p><strong>Owner:</strong> {owner.ownerName || owner.name || 'N/A'}</p>
              <p><strong>Contact:</strong> {owner.ownerPhone || owner.phone || 'N/A'}</p>
              {owner.companyName && <p><strong>Company:</strong> {owner.companyName}</p>}
            </>
          )}
        </div>
      );
    }
    
    if (isBooked) {
      // Show booked seat info with passenger details - PNR is prominently displayed
      const pnr = getPnr();
      const passengerName = getPassengerName();
      const info = passengerDetails || bookingInfo?.passengerDetails || bookingInfo;
      
      return (
        <div className="seat-tooltip-content booked-tooltip">
          <h4>🎫 Booked Seat</h4>
          <p><strong>Seat:</strong> {seatNumber}</p>
          {pnr && (
            <p className="pnr-highlight"><strong>🎟️ PNR:</strong> <span className="pnr-value">{pnr}</span></p>
          )}
          <p><strong>Name:</strong> {passengerName || info?.name || info?.passengerName || 'N/A'}</p>
          {info?.age && <p><strong>Age:</strong> {info.age}</p>}
          {info?.gender && <p><strong>Gender:</strong> {info.gender}</p>}
          {info?.mobile && <p><strong>Contact:</strong> {info.mobile}</p>}
          {info?.email && <p><strong>Email:</strong> {info.email}</p>}
          {(info?.from || info?.to) && (
            <p><strong>Route:</strong> {info.from || 'N/A'} → {info.to || 'N/A'}</p>
          )}
          {(info?.boardingPoint || info?.droppingPoint) && (
            <>
              {info.boardingPoint && <p><strong>Boarding:</strong> {info.boardingPoint}</p>}
              {info.droppingPoint && <p><strong>Dropping:</strong> {info.droppingPoint}</p>}
            </>
          )}
          {info?.bookingType && <p><strong>Booking Type:</strong> {info.bookingType}</p>}
          {info?.fare && <p><strong>Fare:</strong> ₹{info.fare}</p>}
          {info?.totalAmount && <p><strong>Total:</strong> ₹{info.totalAmount}</p>}
        </div>
      );
    }
    
    // Available seat
    return (
      <div className="seat-tooltip-content available-tooltip">
        <p><strong>Seat:</strong> {seatNumber}</p>
        <p><strong>Status:</strong> Available ✓</p>
      </div>
    );
  };
  
  return (
    <div 
      className="seat-tooltip-wrapper"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      {showTooltip && (
        <div className="seat-tooltip-popup">
          {getTooltipContent()}
        </div>
      )}
    </div>
  );
};

const LiveSeatStatusModal = ({ bus, token, onClose }) => {
  console.log("Bus ::::::::::::: ", bus);
  const [selectedDate, setSelectedDate] = useState(getTodayStr());
  const [selectedDirection, setSelectedDirection] = useState('UP');
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  
  // State for seat data from API
  const [seatData, setSeatData] = useState(null);
  const [bookedSeatsMap, setBookedSeatsMap] = useState({});
  const [blockedSeatsMap, setBlockedSeatsMap] = useState({});
  const [totalBookedSeats, setTotalBookedSeats] = useState(0);
  const [totalBlockedSeats, setTotalBlockedSeats] = useState(0);
  const [availableSeats, setAvailableSeats] = useState(bus.totalSeats || 0);
  const [instantCounts, setInstantCounts] = useState({ UP: 0, DOWN: 0, total: 0 });
  const [busOwner, setBusOwner] = useState(null);

  // Extract time slots from bus routeSchedules
  const extractTimeSlots = () => {
    const slots = [];
    
    console.log('Bus routeSchedules:', bus.routeSchedules);
    
    if (bus.routeSchedules && bus.routeSchedules.length > 0) {
      const routeSchedule = bus.routeSchedules.find(rs => rs.direction === selectedDirection);
      
      console.log('Route schedule for direction:', selectedDirection, routeSchedule);
      
      if (routeSchedule) {
        const originTimings = routeSchedule.origin?.timings || [];
        const destTimings = routeSchedule.destination?.timings || [];
        
        if (originTimings.length > 0) {
          originTimings.forEach(timing => {
            const slotNumber = timing.timeSlotSequence || 1;
            const departureTime = timing.departureTime;
            
            let arrivalTime = null;
            if (destTimings.length > 0) {
              const destTiming = destTimings.find(
                t => t.timeSlotSequence === slotNumber
              );
              if (destTiming) {
                arrivalTime = destTiming.arrivalTime;
              }
            }
            
            if (departureTime) {
              slots.push({
                slot: slotNumber,
                departureTime: departureTime,
                arrivalTime: arrivalTime || 'N/A',
                label: `Slot ${slotNumber} - ${departureTime} → ${arrivalTime || 'N/A'}`
              });
            }
          });
        }
        
        if (slots.length === 0 && destTimings.length > 0) {
          destTimings.forEach(timing => {
            const slotNumber = timing.timeSlotSequence || 1;
            const arrivalTime = timing.arrivalTime;
            
            let departureTime = null;
            if (originTimings.length > 0) {
              const originTiming = originTimings.find(
                t => t.timeSlotSequence === slotNumber
              );
              if (originTiming) {
                departureTime = originTiming.departureTime;
              }
            }
            
            if (arrivalTime) {
              slots.push({
                slot: slotNumber,
                departureTime: departureTime || 'N/A',
                arrivalTime: arrivalTime,
                label: `Slot ${slotNumber} - ${departureTime || 'N/A'} → ${arrivalTime}`
              });
            }
          });
        }
        
        if (slots.length === 0) {
          const departureTime = routeSchedule.origin?.departureTime || 'N/A';
          const arrivalTime = routeSchedule.destination?.arrivalTime || 'N/A';
          if (departureTime !== 'N/A' || arrivalTime !== 'N/A') {
            slots.push({
              slot: 1,
              departureTime: departureTime,
              arrivalTime: arrivalTime,
              label: `Slot 1 - ${departureTime} → ${arrivalTime}`
            });
          }
        }
      }
    }
    
    if (slots.length === 0) {
      slots.push({
        slot: 1,
        departureTime: 'N/A',
        arrivalTime: 'N/A',
        label: 'Slot 1'
      });
    }
    
    slots.sort((a, b) => a.slot - b.slot);
    console.log('Extracted time slots:', slots);
    setAvailableTimeSlots(slots);
    
    if (!slots.some(s => s.slot === selectedTimeSlot)) {
      setSelectedTimeSlot(slots[0]?.slot || 1);
    }
  };

  // Fetch seat availability from API
// Fetch seat availability from API
const fetchSeatAvailability = async () => {
  try {
    setLoading(true);
    setError(null);

    console.log('📡 Fetching seat availability with:', {
      busId: bus.id,
      date: selectedDate,
      direction: selectedDirection,
      timeSlot: selectedTimeSlot
    });

    const response = await getBusSeatAvailability(
      token,
      bus.id,
      selectedDate,
      selectedDirection,
      selectedTimeSlot
    );

    console.log('📦 Seat availability response:', response);

    if (response && response.success) {
      setSeatData(response);
      
      // Store bus owner info
      if (response.bus && response.bus.owner) {
        setBusOwner(response.bus.owner);
      }
      
      // Find the direction data
      const directionData = response.directions?.find(
        d => d.direction === selectedDirection
      );
      
      if (directionData) {
        // Find the time slot data
        const slotData = directionData.timeSlots?.find(
          s => s.timeSlot === selectedTimeSlot
        );
        
        if (slotData) {
          // Process seat data
          const bookedMap = {};
          const blockedMap = {};
          
          // Create a map of seat data from API
          const seatDataMap = {};
          slotData.seats?.forEach(seat => {
            seatDataMap[seat.seatNumber] = seat;
            
            if (seat.isBooked && !seat.isCancelled) {
              // Store all passenger details including PNR
              const passengerDetails = seat.passengerDetails || {};
              bookedMap[seat.seatNumber] = {
                passengerName: seat.passengerName || passengerDetails?.name || 'Unknown',
                bookingId: seat.bookingId,
                pnr: seat.pnr || passengerDetails?.pnr || null,
                initials: seat.passengerName ? getInitials(seat.passengerName) : 'B',
                passengerDetails: {
                  name: passengerDetails?.name || seat.passengerName || 'Unknown',
                  age: passengerDetails?.age || null,
                  gender: passengerDetails?.gender || null,
                  mobile: passengerDetails?.mobile || null,
                  email: passengerDetails?.email || null,
                  from: passengerDetails?.from || null,
                  to: passengerDetails?.to || null,
                  boardingPoint: passengerDetails?.boardingPoint || null,
                  droppingPoint: passengerDetails?.droppingPoint || null,
                  fare: passengerDetails?.fare || null,
                  totalAmount: passengerDetails?.totalAmount || null,
                  bookingType: passengerDetails?.bookingType || seat.bookingType || 'customer',
                  pnr: seat.pnr || passengerDetails?.pnr || null
                }
              };
            }
            if (seat.isBlocked) {
              blockedMap[seat.seatNumber] = true;
            }
          });
          
          // Store the seat data for tooltips
          setBookedSeatsMap(bookedMap);
          setBlockedSeatsMap(blockedMap);
          setTotalBookedSeats(slotData.bookedSeats || 0);
          setTotalBlockedSeats(slotData.blockedSeats || 0);
          setAvailableSeats(slotData.availableSeats || 0);
          
          // Update instant counts if available
          if (slotData.instantCounts) {
            setInstantCounts(slotData.instantCounts);
          }
        }
      }
    } else {
      setError(response?.message || 'Failed to fetch seat availability');
      // Fallback to bookings API
      await fetchBookingsFallback();
    }
  } catch (err) {
    console.error('Error fetching seat availability:', err);
    setError(err.message || 'Failed to load seat availability');
    // Fallback to bookings API
    await fetchBookingsFallback();
  } finally {
    setLoading(false);
  }
};

  // Fallback: Use existing bookings API
  const fetchBookingsFallback = async () => {
    try {
      console.log('🔄 Using fallback bookings API');
      const response = await getBookingsByDateAndBus(token, bus.id, selectedDate);
      if (response && response.success) {
        const bookings = response.data || [];
        processBookingsData(bookings);
      }
    } catch (err) {
      console.error('Error in fallback:', err);
      setError('Failed to load seat data. Please try again.');
    }
  };

  // Process bookings data (fallback)
  const processBookingsData = (bookings) => {
    const instant = { UP: 0, DOWN: 0, total: 0 };
    const bookedMap = {};
    const blockedMap = {};

    // Get blocked seats from bus data
    (bus.seats || []).forEach(seat => {
      if (seat.isBlocked === true) {
        blockedMap[seat.seatNumber] = true;
      }
    });

    bookings.forEach((booking) => {
      const direction = booking.journeyDetails?.direction === 'DOWN' ? 'DOWN' : 'UP';
      const timeSlot = booking.timeSlotSequence || 1;
      
      if (direction === selectedDirection && timeSlot === selectedTimeSlot) {
        const status = (booking.status || '').toLowerCase();
        const isActive = ACTIVE_STATUSES.includes(status);
        
        if (!isActive) return;

        if (booking.isInstantBooking) {
          instant[direction] += 1;
          instant.total += 1;
          return;
        }

        if (booking.seats) {
          booking.seats.forEach((seat) => {
            if (seat.seatNumber) {
              bookedMap[seat.seatNumber] = {
                passengerName: seat.passenger?.fullName || 'Unknown',
                bookingId: booking._id,
                pnr: booking.pnr || booking.maskedPnr,
                initials: seat.passenger?.fullName ? getInitials(seat.passenger.fullName) : 'B',
                passengerDetails: {
                  name: seat.passenger?.fullName || 'Unknown',
                  age: seat.passenger?.age || null,
                  gender: seat.passenger?.gender || null,
                  mobile: seat.passenger?.mobileNumber || null,
                  email: seat.passenger?.email || null,
                  from: booking.route?.from || null,
                  to: booking.route?.to || null,
                  bookingType: booking.isManual ? 'manual' : 'customer',
                  pnr: booking.pnr || booking.maskedPnr
                }
              };
            }
          });
        }
      }
    });

    setInstantCounts(instant);
    setBookedSeatsMap(bookedMap);
    setBlockedSeatsMap(blockedMap);
    setTotalBookedSeats(Object.keys(bookedMap).length);
    setTotalBlockedSeats(Object.keys(blockedMap).length);
    setAvailableSeats(bus.totalSeats - Object.keys(bookedMap).length - Object.keys(blockedMap).length);
  };

  // Initial load and when date/direction/time slot changes
  useEffect(() => {
    extractTimeSlots();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDirection]);

  useEffect(() => {
    if (bus.id && selectedDate) {
      fetchSeatAvailability();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, selectedDirection, selectedTimeSlot]);

  // left/right seat counts derived from bus.seatConfiguration.busType
  const { left: leftCount, right: rightCount } = useMemo(
    () => parseSeatConfig(bus.seatConfiguration?.busType),
    [bus.seatConfiguration]
  );

  // Group the bus's static seat layout by row
  const seatRows = useMemo(() => {
    const rowsMap = {};
    (bus.seats || []).forEach((seat) => {
      if (!rowsMap[seat.row]) rowsMap[seat.row] = [];
      rowsMap[seat.row].push(seat);
    });
    return Object.keys(rowsMap)
      .map(Number)
      .sort((a, b) => a - b)
      .map((rowNum) => rowsMap[rowNum].sort((a, b) => a.column - b.column));
  }, [bus.seats]);

  const renderSeatBox = (seat) => {
    const info = bookedSeatsMap[seat.seatNumber];
    const isBooked = !!info;
    const isBlocked = seat.isBlocked === true || blockedSeatsMap[seat.seatNumber] === true;
    
    // Attach API data to seat for tooltip
    const seatWithData = {
      ...seat,
      _apiData: seatData?.directions
        ?.find(d => d.direction === selectedDirection)
        ?.timeSlots
        ?.find(s => s.timeSlot === selectedTimeSlot)
        ?.seats
        ?.find(s => s.seatNumber === seat.seatNumber) || null
    };

    const getSeatClassName = () => {
      if (isBlocked) return 'seat-blocked';
      if (isBooked) return 'seat-booked';
      return 'seat-available';
    };

    const getSeatDisplayText = () => {
      if (isBlocked) return '🚫';
      if (isBooked) return info?.initials || 'B';
      return seat.seatNumber;
    };

    return (
      <SeatTooltip
        key={seat.seatNumber}
        seat={seatWithData}
        bookedSeatsMap={bookedSeatsMap}
        blockedSeatsMap={blockedSeatsMap}
        busOwner={busOwner}
      >
        <div
          className={`seat-box ${getSeatClassName()}`}
        >
          {getSeatDisplayText()}
        </div>
      </SeatTooltip>
    );
  };

  const renderSeatGrid = () => {
    if (seatRows.length === 0) {
      return <p style={{ fontSize: '13px', color: '#666' }}>No seat layout available for this bus.</p>;
    }

    return (
      <div className="seat-grid1">
        {seatRows.map((row, rowIdx) => {
          const isBackRow = row.every((s) => s.position === 'back');

          if (isBackRow) {
            return (
              <div className="seat-row seat-row-back" key={rowIdx}>
                {row.map((seat) => renderSeatBox(seat))}
              </div>
            );
          }

          const leftSeats = row.filter((s) => s.position === 'left' || s.column <= leftCount);
          const rightSeats = row.filter((s) => s.position === 'right' || s.column > leftCount);
          
          const finalLeftSeats = leftSeats.length > 0 ? leftSeats : row.slice(0, leftCount);
          const finalRightSeats = rightSeats.length > 0 ? rightSeats : row.slice(leftCount);

          return (
            <div className="seat-row" key={rowIdx}>
              <div className="seat-row-block seat-row-left">
                {finalLeftSeats.map((seat) => renderSeatBox(seat))}
              </div>
              <div className="seat-aisle-gap" />
              <div className="seat-row-block seat-row-right">
                {finalRightSeats.map((seat) => renderSeatBox(seat))}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  // Get current time slot label
  const getCurrentTimeSlotLabel = () => {
    const slot = availableTimeSlots.find(s => s.slot === selectedTimeSlot);
    if (slot) {
      return `${slot.departureTime || 'N/A'} → ${slot.arrivalTime || 'N/A'}`;
    }
    return 'N/A → N/A';
  };

  const totalSeats = bus.totalSeats || 0;
  const totalAvailableSeats = totalSeats - totalBookedSeats - totalBlockedSeats;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content1 seat-status-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Live Seat Status: {bus.busNumber} - {bus.busName}</h3>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Controls: Date, Direction, Time Slot */}
          <div className="seat-status-controls">
            <div className="control-group">
              <label>
                Date:&nbsp;
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                />
              </label>
            </div>

            <div className="control-group">
              <label>
                Direction:&nbsp;
                <select 
                  value={selectedDirection} 
                  onChange={(e) => setSelectedDirection(e.target.value)}
                  className="direction-select"
                >
                  <option value="UP">UP Journey</option>
                  <option value="DOWN">DOWN Journey</option>
                </select>
              </label>
            </div>

            <div className="control-group">
              <label>
                Time Slot:&nbsp;
                <select 
                  value={selectedTimeSlot} 
                  onChange={(e) => setSelectedTimeSlot(Number(e.target.value))}
                  className="timeslot-select"
                >
                  {availableTimeSlots.map((slot) => (
                    <option key={slot.slot} value={slot.slot}>
                      Slot {slot.slot} - {slot.departureTime || 'N/A'} → {slot.arrivalTime || 'N/A'}
                    </option>
                  ))}
                </select>
              </label>
            </div>

            <button className="refresh-btn" onClick={fetchSeatAvailability}>
              Refresh
            </button>
          </div>

          {/* Trip Info */}
          <div className="trip-info">
            <div className="trip-route">
              <span className="direction-label">{selectedDirection} Journey</span>
              <span className="time-slot-label">
                Slot {selectedTimeSlot} - {getCurrentTimeSlotLabel()}
              </span>
            </div>
            <div className="bus-info-summary">
              <span className="bus-name">{bus.busName}</span>
              <span className="bus-number">{bus.busNumber}</span>
              <span className="seat-count">
                Available Seats: {totalAvailableSeats} / {totalSeats}
              </span>
            </div>
          </div>

          {loading && <p className="loading-text">Loading seat status...</p>}
          {error && <p className="error-text" style={{ color: 'red' }}>{error}</p>}

          {!loading && !error && (
            <>
              <div className="instant-badges-row">
                <div className="instant-ticket-badge">
                  Instant Tickets (UP): <strong>{instantCounts.UP || 0}</strong>
                </div>
                <div className="instant-ticket-badge">
                  Instant Tickets (DOWN): <strong>{instantCounts.DOWN || 0}</strong>
                </div>
                <div className="instant-ticket-badge">
                  Total Instant: <strong>{instantCounts.total || 0}</strong>
                </div>
                <div className="instant-ticket-badge">
                  Total Seats Booked: <strong>{totalBookedSeats}</strong>
                </div>
                <div className="instant-ticket-badge blocked-badge">
                  Blocked: <strong>{totalBlockedSeats}</strong>
                </div>
              </div>

              <div className="seat-legend">
                <span><span className="legend-swatch seat-available"></span> Available</span>
                <span><span className="legend-swatch seat-booked"></span> Booked</span>
                <span><span className="legend-swatch seat-blocked"></span> Blocked</span>
              </div>

              <div className="seat-grid-wrapper">
                <div className="seat-grid-column">
                  <h4 style={{ textAlign: 'center' }}>
                    {selectedDirection} Direction - Slot {selectedTimeSlot}
                  </h4>
                  {renderSeatGrid()}
                </div>
              </div>

              {/* Driver & Conductor Info */}
              {(bus.driver || bus.conductor) && (
                <div className="staff-info">
                  {bus.driver && (
                    <div className="staff-item">
                      <span className="staff-label">Driver:</span>
                      <span className="staff-name">{bus.driver.name || 'N/A'}</span>
                    </div>
                  )}
                  {bus.conductor && (
                    <div className="staff-item">
                      <span className="staff-label">Conductor:</span>
                      <span className="staff-name">{bus.conductor.name || 'N/A'}</span>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="modal-close-btn secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LiveSeatStatusModal;